module.exports = __webpack_public_path__ + "static/media/mn.47b46adb.svg";